import React from 'react';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import BlockOutlinedIcon from '@material-ui/icons/BlockOutlined';

const useStyles = makeStyles(theme => ({

    root: {
        height: '40%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    icon: {
        fontSize: '12rem !important',
        marginBottom: theme.spacing(6),
        color: theme.palette.error.main,
    },
    message: {
        marginTop: theme.spacing(2)
    }

}))

export const FingotiNoPermission = () => {

    const classes = useStyles();

    return (
        <Box display='flex' height='80vh' alignItems='center' justifyContent='center'>
            <Box display='flex' flexDirection='column' alignItems='center'>
                <BlockOutlinedIcon className={classes.icon} />
                <Typography variant='h3'>No Permission</Typography>
                <Typography className={classes.message}>You don't have permission to access this page, please contact the organisation administrator to request permission</Typography>
            </Box>
        </Box>
    );

}